import React from "react";
import { resolveUrl } from "./erRendererStyleUtils";
import { resolveButtonBorderRadiusCss } from "./buttonBorderRadius";

export function isButtonImageMode(content) {
	return !!content?.buttonUseImage;
}

export default function ButtonImageVisual({ content, style, isHovered, disabled, placeholder = "Imagen" }) {
	const url = content?.buttonImageUrl;
	const hoverUrl = content?.buttonHoverImageUrl;
	const hoverMode = content?.buttonImageHoverMode === "swap" ? "swap" : "multiply";
	const hoverColor = content?.buttonImageHoverColor || "rgba(124, 58, 237, 1)";
	const hoverOpacityRaw = Number(content?.buttonImageHoverOpacity);
	const hoverOpacity = Number.isFinite(hoverOpacityRaw) ? Math.max(0, Math.min(1, hoverOpacityRaw)) : 0.45;
	const fit = content?.buttonImageFit === "contain" ? "contain" : "cover";
	const radiusCss = resolveButtonBorderRadiusCss(style);
	const resolved = resolveUrl(url);
	const resolvedHover = resolveUrl(hoverUrl);
	const canHover = isHovered && !disabled;
	const showSwap = canHover && hoverMode === "swap" && !!resolvedHover;
	const showMultiply = canHover && hoverMode === "multiply";
	const shellStyle = {
		position: "relative",
		width: "100%",
		height: "100%",
		overflow: "hidden",
		borderRadius: radiusCss,
		background: "transparent",
		opacity: disabled ? 0.55 : 1,
		isolation: "isolate",
	};
	const imageMaskStyle = {
		WebkitMaskImage: `url("${resolved.replace(/"/g, '\\"')}")`,
		maskImage: `url("${resolved.replace(/"/g, '\\"')}")`,
		WebkitMaskSize: fit,
		maskSize: fit,
		WebkitMaskPosition: "center",
		maskPosition: "center",
		WebkitMaskRepeat: "no-repeat",
		maskRepeat: "no-repeat",
	};

	if (!resolved) {
		return (
			<div style={{ ...shellStyle, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: 12 }}>
				{placeholder}
			</div>
		);
	}

	return (
		<div style={shellStyle}>
			<img
				src={showSwap ? resolvedHover : resolved}
				alt=""
				draggable={false}
				style={{ width: "100%", height: "100%", objectFit: fit, display: "block", pointerEvents: "none" }}
			/>
			{showMultiply ? (
				<div
					style={{
						position: "absolute",
						inset: 0,
						backgroundColor: hoverColor,
						opacity: hoverOpacity,
						mixBlendMode: "multiply",
						pointerEvents: "none",
						...imageMaskStyle,
					}}
				/>
			) : null}
		</div>
	);
}
